


















































import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
import Jumbo from '@/components/informational/Jumbo.vue'
import FeatureList from '@/components/informational/FeatureList.vue'
import RichText from '@/components/informational/RichText.vue'
import Feature from '@/components/informational/Feature.vue'
import Testimonial from '@/components/informational/Testimonial.vue'
import Carousel from '@/components/informational/Carousel.vue'
import { getFeature, getIndustry } from '@/services/cms'

@Component({
  components: {
    Jumbo,
    FeatureList,
    RichText,
    Feature,
    Testimonial,
    Carousel,
  },
})
export default class CMSSemanticPage extends Vue {

  @Prop({ type: String }) type!: string

  title = 'Feature'
  color = 'primary'
  body: any[] = []

  metaInfo() {
    return {
      title: this.title,
    }
  }

  @Watch('$route.params.contentId')
  onRouteChange() {
    this.init()
  }

  mounted() {
    this.init()
  }

  async init() {

    let endpoint
    switch (this.type) {
      case 'feature':
        endpoint = getFeature
        break
      case 'industry':
        endpoint = getIndustry
        break
    }

    if (!endpoint) return

    const { name, body, color } = await endpoint(this.$route.params.contentId)
    
    this.title = name
    this.body = body
    this.color = color
  }

  imageUrl(item: any, attributeName='image', size = 'medium') {
    const attrs = item[attributeName]?.data?.attributes
    if (!attrs?.formats) return attrs?.url
    return attrs?.formats[size]?.url || attrs?.url
  }

  mapCarouselItems(item: any) {
    return item.carouselItems.map((carouselItem: any) => {
      return {
        src: this.imageUrl(carouselItem, 'image', 'large'),
        caption: carouselItem.caption,
      }
    })
  }

  computeColor(item: any) {
    return item.color === 'default' ? '' : (item.color || this.color)
  }
}
